export var EventCategory;
(function (EventCategory) {
    EventCategory["Onboarding"] = "Onboarding";
    EventCategory["Target"] = "Target";
    EventCategory["Baseline"] = "Baseline";
    EventCategory["Dashboard"] = "Dashboard";
    EventCategory["Plan"] = "Plan";
    EventCategory["LeadGen"] = "LeadGen";
    EventCategory["Feedback"] = "Feedback";
    EventCategory["NavigationMenu"] = "NavigationMenu";
    EventCategory["Email"] = "Email";
    EventCategory["FAQ"] = "FAQ";
    EventCategory["GuidedTour"] = "GuidedTour";
})(EventCategory || (EventCategory = {}));
